import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const spinnerTheme: ThemeOptions['components'] = {
  MuiCircularProgress: {
    styleOverrides: {
      circle: {
        strokeLinecap: 'round',
      },
      root: ({ ownerState }) => ({
        boxSizing: 'border-box',
        '& svg': {
          zIndex: '1',
          position: 'relative',
        },
        '&.DS-Spinner-withBackground:before': {
          content: "''",
          position: 'absolute',
          inset: 0,
          border: `${ownerState.thickness! / 44}em solid ${
            tokens.theme.bg.structural.surfaceRaised
          }`,
          borderRadius: tokens.theme.radius.full,
        },
        '&.MuiCircularProgress-color': {
          '&Primary': {
            color: tokens.theme.bg.status.infoStrong,
          },
          '&Secondary': {
            color: tokens.theme.bg.status.successStrong,
          },
          '&Tertiary': {
            color: tokens.theme.fg.status.neutral,
          },
        },
      }),
    },
  },
};
